import { useCallback, useRef, useState } from 'react';

export const useLastActivity = (): {
  lastActivity: number;
  timeUserHasBeenIdle: number;
  setLastActivity: React.Dispatch<React.SetStateAction<number>>;
} => {
  const [lastActivity, setLastActivity] = useState(() => Date.now());
  const lastActivityRef = useRef(lastActivity);

  const wrappedSetLastActivity: React.Dispatch<React.SetStateAction<number>> = useCallback(value => {
    setLastActivity(prev => {
      const next = typeof value === 'function' ? value(prev) : value;
      lastActivityRef.current = next;
      return next;
    });
  }, []);

  // eslint-disable-next-line react-hooks/purity -- timeUserHasBeenIdle is intentionally time-dependent and only consumed in event callbacks, not during render
  const now = Date.now();
  return { lastActivity, timeUserHasBeenIdle: now - lastActivityRef.current, setLastActivity: wrappedSetLastActivity };
};
